import React, { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import { useTranslation } from 'react-i18next'
import L from 'leaflet'

export const TotalHectaresControl = ({ totalHectares }) => {
  const map = useMap()
  const { t } = useTranslation()

  useEffect(() => {
    let totalHectaresValue = parseFloat(totalHectares)
    if (isNaN(totalHectaresValue)) {
      totalHectaresValue = 0
    }

    const controlDiv = L.DomUtil.create('div')
    controlDiv.style.background = '#fff'
    controlDiv.style.border = '1.5px solid rgba(0,0,0,0.1)'
    controlDiv.style.borderRadius = '12px'
    controlDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)'
    controlDiv.style.padding = '6px 12px'
    controlDiv.style.display = 'inline-flex'
    controlDiv.style.alignItems = 'baseline'
    controlDiv.style.gap = '6px'
    controlDiv.style.color = 'rgba(0,0,0,0.87)'
    controlDiv.style.font =
      '500 0.75rem/1.4 Roboto, "Fira Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    controlDiv.style.letterSpacing = '0.04em'
    controlDiv.style.textTransform = 'uppercase'

    const labelEl = document.createElement('span')
    labelEl.style.color = 'rgba(0,0,0,0.54)'
    labelEl.style.fontWeight = '600'
    labelEl.textContent = t('total-hectares')

    const valueEl = document.createElement('span')
    valueEl.style.color = '#232C57'
    valueEl.style.fontWeight = '700'
    valueEl.style.fontSize = '0.875rem'
    valueEl.style.textTransform = 'none'
    valueEl.textContent = `${totalHectaresValue.toFixed(2)} ha`

    controlDiv.appendChild(labelEl)
    controlDiv.appendChild(valueEl)

    L.DomEvent.disableClickPropagation(controlDiv)
    L.DomEvent.disableScrollPropagation(controlDiv)

    const control = L.control({ position: 'bottomleft' })
    control.onAdd = () => controlDiv
    control.addTo(map)

    return () => {
      map.removeControl(control)
    }
  }, [map, totalHectares, t])

  return null
}
